export default "__VITE_ASSET__RR7svZPZ__"